import { BaseAction } from "./BaseAction";
export class SmallInfoBoxAction extends BaseAction {
    execute() {
        this.renderTemplate();
        return true;
    }
}
